import { defineRecipe } from "@chakra-ui/react/styled-system";

// Variants for Text where a shared presentation would otherwise be repeated
// as style props at every call site.
export default defineRecipe({
  variants: {
    variant: {
      // A validation message under a form section: the field-error colour,
      // kept against the section's leading edge.
      validation: {
        textStyle: "sm",
        color: "fg.error",
        alignSelf: "start",
      },
    },
  },
});
